import React, { useEffect, useState } from "react";
import Icon from "@components/AppIcon";

const MedicalPhilosophy = () => {
  const [pillars, setPillars] = useState([]);

  useEffect(() => {
    const fetchPhilosophy = async () => {
      try {
        const res = await fetch("/api/about_us");
        const data = await res.json();

        if (Array.isArray(data) && data.length > 0) {
          const aboutEntry = data[0];
          const sections = aboutEntry.sections || [];

          // ✅ find philosophy section
          const philosophySection = sections.find(
            (s) => s.type === "our_philosophy" && s.enabled
          );

          if (philosophySection && philosophySection.our_philosophy) {
            const mapped = philosophySection.our_philosophy
              .filter((p) => p.enabled) // only enabled pillars
              .map((p, i) => ({
                title: p.philosophy_name,
                description:
                  p.philosophy_description?.[0]?.content?.[0]?.text || "",
                icon: guessIcon(p.philosophy_name),
                color: pickColor(i),
              }));

            setPillars(mapped);
          }
        }
      } catch (error) {
        console.error("Error fetching philosophy:", error);
      }
    };

    fetchPhilosophy();
  }, []);

  // ✅ Assign icons based on name
  const guessIcon = (name) => {
    if (name.includes("Ubuntu")) return "Heart";
    if (name.includes("Innovation")) return "Zap";
    if (name.includes("Community")) return "Users";
    if (name.includes("Holistic") || name.includes("Vision")) return "Eye";
    return "Star";
  };

  // ✅ Alternate brand colors
  const pickColor = (i) => (i % 2 === 0 ? "#08005f" : "#eb2227");

  if (pillars.length === 0) {
    return null; // nothing enabled → no render
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div
              className="w-12 h-12 rounded-full flex items-center justify-center"
              style={{ backgroundColor: "#08005f1a" }}
            >
              <Icon name="Compass" size={24} color="#08005f" strokeWidth={2} />
            </div>
            <span
              className="font-heading font-semibold text-lg"
              style={{ color: "#08005f" }}
            >
              Our Philosophy
            </span>
          </div>
          <h2
            className="font-heading font-bold text-3xl lg:text-4xl mb-6"
            style={{ color: "#08005f" }}
          >
            Where Modern Medicine
            <span className="block" style={{ color: "#eb2227" }}>
              Meets Cultural Wisdom
            </span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Our medical philosophy is rooted in the understanding that
            exceptional healthcare must honor both scientific excellence and
            cultural intelligence, creating healing experiences that resonate
            with the hearts and minds of our patients.
          </p>
        </div>

        {/* Philosophy Pillars */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-[#f5f6fa] rounded-2xl p-6 hover:bg-[#e8eafd] hover:medical-shadow medical-transition border"
              style={{ borderColor: `${pillar.color}22` }}
            >
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
                style={{ backgroundColor: `${pillar.color}1a` }}
              >
                <Icon
                  name={pillar.icon}
                  size={28}
                  color={pillar.color}
                  strokeWidth={2}
                />
              </div>
              <h3
                className="font-heading font-semibold text-xl mb-4"
                style={{ color: "#08005f" }}
              >
                {pillar.title}
              </h3>
              <p className="text-text-secondary leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MedicalPhilosophy;
